module.exports = __webpack_public_path__ + "787e78dac31a221389618c928cb15570.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-cool-s.png
// module id = 1819
// module chunks = 0